export const type = 'ADD_PRODUCT';

const findCartResult = (text) => ({
    type,
    name: text,
});

export default findCartResult;
